import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzSelectComponent } from 'ng-zorro-antd/select';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ElementRef,
  ViewChild,
} from '@angular/core';
import {
  AttachedDocument,
  CommunicationParameter,
  CommunicationType,
  MessageInfo,
} from './communication.interface';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import * as moment from 'moment';
import * as g from 'src/app/globals';
import { LayoutService } from '../layout.service';
import { ModuleInformation } from 'src/app/models/module-information';
import { ModuleStructure } from 'src/app/models/module-structure';
import { RecordModel } from '../record-model';
import { OnDestroy } from '@angular/core';
import { Observable } from 'rxjs';
import { tap, switchMap, map } from 'rxjs/operators';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { RecordPageComponent } from '../record-page/record-page.component';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import { toNumber } from 'ng-zorro-antd/core/util';
@Component({
  selector: 'app-communication',
  templateUrl: './communication.component.html',
  styleUrls: ['./communication.component.less'],
})
export class CommunicationComponent implements OnInit, OnDestroy {
  fileData: string | ArrayBuffer;
  selectedTab: CommunicationType;

  constructor(
    private layoutService: LayoutService,
    private router: Router,
    private drawerService: NzDrawerService,
    private msg: NzMessageService,
    private notification: NzNotificationService // private msalService: MsalService,
  ) // private msalBrodcastService: MsalBroadcastService
  {}
  @Input() moduleId: number;
  @Input() recordId: string | number;
  @Input() recordModel: RecordModel;
  @Input() gotoTab: CommunicationType;
  @Input() multiDoc: boolean;
  @Input() layoutId;

  //#region Vars
  messageInfo: MessageInfo = {
    attachDocs: [],
    sendPdf: false,
    uplaod: [],
  };
  attachedDocs = [];
  urlPrefix = '/apps/crm/module-list';
  cardCode: number | string;
  communicatParam: CommunicationParameter = {
    Bcc: [],
    Cc: [],
    HtmlBody: '',
    Subject: '',
    To: [],
    fromCommunication: false,
    trackData: true,
    ITM_HELP_ISPUP: false,
    ITM_ONLINE: 'Y',
    AttachDoc: [],
  };
  fetchingDone = false;
  additionalLayoutsToAdd: Set<number> = new Set<number>();
  additionalLayoutsToPreview = [];
  additionalLayouts = [];
  ITM_HELP_ISPUP = false;
  showMainDoc = true;
  moduleInformation: ModuleInformation;
  moduleStructure: ModuleStructure;
  recontact: Date;
  startTime: Date;
  emailInfo: any = {};
  endDate: Date;
  endTime: Date;
  docType: string;
  searchTxt = '';
  employeesList = [];
  isLoading = true;
  emppSelectedValue = null;
  listOfOption: Array<{ label: string; value: string }> = [];
  emailListOfOption: Array<{ label: string; value: string }> = [];
  listOfTagOptions = [];
  emailListOfTagOptions = [];
  cCemailListOfTagOptions = [];
  emailSubject = '';
  remark = '';
  remarkPh = '';
  remarkMe = '';
  remarkTa = '';
  remarkEm = '';
  remarkNo = '';
  communicationType: CommunicationType[] = [];
  getDocCC: (string | number)[];
  activitiesData = [];
  selectedActivitie = '';
  baseUrl = g.baseUrl;
  urlSuffix = g.getUrlSuffix();
  uploading = false;
  fileList: NzUploadFile[] = [];
  fileName: string[] = [];
  fileBase: string[] = [];
  originFileObj: Array<{ fileName: string; fileBase: string }> = [];
  trackData = false;
  fromCommunication = false;
  intervalId: any;
  includeDocumentPDF = false;
  @ViewChild('toEmailEle') toEmailEle: NzSelectComponent;

  initLoading = true; // bug
  loadingMore = false;
  data: any[] = [];
  list: Array<{ loading: boolean; rows: any }> = [];
  count = 5;
  config: any = {
    airMode: false,
    tabDisable: true,
    popover: {
      table: [
        ['add', ['addRowDown', 'addRowUp', 'addColLeft', 'addColRight']],
        ['delete', ['deleteRow', 'deleteCol', 'deleteTable']],
      ],
      link: [['link', ['linkDialogShow', 'unlink']]],
      air: [
        [
          'font',
          [
            'bold',
            'italic',
            'underline',
            'strikethrough',
            'superscript',
            'subscript',
            'clear',
          ],
        ],
      ],
    },
    height: '200px',
    toolbar: [
      ['misc', ['undo', 'redo']],
      [
        'font',
        [
          'bold',
          'italic',
          'underline',
          'strikethrough',
          'superscript',
          'subscript',
          'clear',
        ],
      ],
      ['fontsize', ['fontsize', 'color']],
      ['para', ['style0', 'ul', 'ol', 'paragraph', 'height']],
      ['insert', ['table', 'link', 'hr']],
    ],
    codeviewFilter: true,
    codeviewFilterRegex:
      /<\/*(?:applet|b(?:ase|gsound|link)|embed|frame(?:set)?|ilayer|l(?:ayer|ink)|meta|object|s(?:cript|tyle)|t(?:itle|extarea)|xml|.*onmouseover)[^>]*?>/gi,
    codeviewIframeFilter: true,
  };
  tabs = [];
  ShowShareCheckBox = true;
  //#endregion
  beforeUpload = (file: NzUploadFile): boolean => {
    this.fileList = this.fileList.concat(file);
    this.readFile(file);
    return false;
  };

  ngOnDestroy(): void {
    clearInterval(this.intervalId);
  }

  ngOnInit(): void {
    this.activitiesList();
    this.intervalId = setInterval(() => {
      this.activitiesList();
    }, 10000);

    this.layoutService.getCommunicationConfigs().subscribe((configs: any) => {
      this.ShowShareCheckBox = configs.ShowShareCheckBox;
    });

    this.layoutService
      .getAllowedCommunicationTypes()
      .subscribe((result: any[]) => {
        result.forEach((type) => {
          if (type === 'phone') {
            this.communicationType.push(CommunicationType.Phone);
            this.tabs.push({
              name: CommunicationType.Phone,
              label: 'Phone',
              icon: 'phone',
            });
          }
          if (type === 'meeting') {
            this.communicationType.push(CommunicationType.Meeting);
            this.tabs.push({
              name: CommunicationType.Meeting,
              label: 'Meeting',
              icon: 'deployment-unit',
            });
          }
          if (type === 'task') {
            this.communicationType.push(CommunicationType.Task);
            this.tabs.push({
              name: CommunicationType.Task,
              label: 'Task',
              icon: 'unordered-list',
            });
          }
          if (type === 'email') {
            this.communicationType.push(CommunicationType.Email);
            this.tabs.push({
              name: CommunicationType.Email,
              label: 'Email',
              icon: 'mail',
            });
          }
          if (type === 'note') {
            this.communicationType.push(CommunicationType.Note);
            this.tabs.push({
              name: CommunicationType.Note,
              label: 'Note',
              icon: 'book',
            });
          }
        });
        // if (this.tabs.length > 0) {
        this.tabs.push({
          name: CommunicationType.Note,
          label: 'Activities',
          icon: 'book',
        });
        // }

        // go to the selected tab
        if (this.gotoTab != null) {
          this.selectedTab = this.tabs.findIndex(
            (index) => index.name === this.gotoTab
          );
          const interval = setInterval(() => {
            if (this.fetchingDone) {
              if (
                this.tabs[this.selectedTab].name === CommunicationType.Email
              ) {
                setTimeout(() => {
                  this.GetEmailTemplateInfo();
                }, 5000);
              }
              clearInterval(interval);
            }
          }, 2000);
          // setTimeout(() => {
          // }, 5000);
        }
      });

    this.layoutService.parameterDataSource('').subscribe((result) => {
      // tslint:disable-next-line: forin
      const children: Array<{ label: string; value: string }> = [];
      // tslint:disable-next-line: forin
      for (const key in result) {
        children.push({ label: result[key].id, value: result[key].text });
      }

      this.emailListOfOption = children;
      this.isLoading = false;
      // if (
      //   this.recordModel.ObjectCode !== '191' &&
      //   !this.multiDoc &&
      //   this.recordModel.ObjectCode !== '4'
      // ) {
      this.layoutService
        .getDocumentCardCode(
          this.recordModel.ObjectCode,
          this.recordId.toString()
        )
        .subscribe((d: any) => {
          if (d.rows[0] != null && d.rows[0].mail != '') {
            this.emailListOfTagOptions = [d.rows[0].mail];
          }
          // this.toEmailEle.activatedValue = d.rows[0].mail;
        });
      // }
    });

    this.layoutService
      .getEmployeesList()
      .subscribe((result: { rows: any[] }) => {
        // tslint:disable-next-line: forin
        const children: Array<{ label: string; value: string }> = [];
        // tslint:disable-next-line: forin
        for (const key in result.rows) {
          children.push({
            label: result.rows[key].Name,
            value: result.rows[key].Code,
          });
        }

        this.listOfOption = children;
        this.isLoading = false;
      });

    this.initializeList();
  }
  includeDocumentPDFChanged() {
    if (this.messageInfo.sendPdf) {
      if (
        this.moduleStructure.module.LayoutDefinitionId === 0 ||
        this.moduleStructure.module.LayoutDefinitionId === undefined ||
        this.moduleStructure.module.LayoutDefinitionId === null
      ) {
        this.msg.error(
          this.layoutService.translate(
            "Can't attach document as there is no layout defined for this module."
          )
        );
        this.messageInfo.sendPdf = false;
      } else {
        this.AddDocumentPDF();
      }
    } else {
      this.communicatParam.AttachDoc = [];
      this.attachedDocs = [];
    }
  }
  includeMutliAdditionalLayouts(layout, status) {
    let recordsIds: any[] = [];
    if (this.recordId.toString().indexOf(',') !== -1) {
      recordsIds = this.recordId.toString().split(',');
    } else {
      recordsIds = [this.recordId];
    }
    recordsIds.forEach((id) => {
      this.includeAdditionalLayout(layout, status, id);
    });
  }
  includeAdditionalLayout(layout, status: boolean, docEntry = '') {
    if (layout == null) {
      return;
    }
    const layoutId = layout.Id;
    if (status) {
      this.additionalLayoutsToAdd.add(layoutId);
      if (this.multiDoc) {
        this.additionalLayoutsToPreview.push({
          DocEntry: docEntry,
          LayoutId: layoutId,
          ModuleId: this.moduleStructure.module.Id,
          Description: `${layout.FieldDescription} ${docEntry}`,
        });
      } else {
        this.additionalLayoutsToPreview.push(layout);
      }
    } else {
      // tslint:disable-next-line: no-unused-expression
      this.additionalLayoutsToAdd.has(layoutId)
        ? this.additionalLayoutsToAdd.delete(layoutId)
        : // tslint:disable-next-line: no-unused-expression
          null;
      if (this.multiDoc) {
        const index = this.additionalLayoutsToPreview.findIndex(
          (l) => l.LayoutId !== layoutId
        );
        this.additionalLayoutsToPreview.splice(index, 1);
      } else {
        const index = this.additionalLayoutsToPreview.findIndex(
          (x) => x.Id === layoutId
        );
        this.additionalLayoutsToPreview.splice(index, 1);
      }
    }
  }
  displayDocumentPDF(id = null, docEntry = '') {
    const layoutId = id ? id : this.moduleStructure.module.LayoutDefinitionId;
    const keyValue =
      docEntry === '' || docEntry == null
        ? this.recordModel.KeyValue
        : docEntry;
    const url =
      g.apiBaseUrl +
      `Report/PrintObject?moduleId=${
        this.moduleId
      }&selectedId=${keyValue}&id=${layoutId}&exportMode=5&mode=preview&${g.getUrlSuffix()}`;
    window.open(url);
  }

  initializeList() {
    this.additionalLayouts = [];
    this.layoutService
      .getModuleStructure(this.moduleId)
      .pipe(
        map((structure: ModuleStructure) => {
          this.moduleStructure = structure;
          const additionalLays =
            structure.module.AdditionalInformationParsed.AdditionalLayouts;
          const mainLayoutId = this.moduleStructure.module.LayoutDefinitionId;
          if (mainLayoutId != null && mainLayoutId !== 0) {
            additionalLays.push(mainLayoutId);
          }
          let unique = [];
          if (additionalLays.length > 0) {
            unique = additionalLays.filter(
              (el, index, self) => self.indexOf(el) === index
            );
          }
          // unique.push(mainLayoutId);
          this.showMainDoc = false;
          return unique;
        }),
        switchMap((unique: any[]) => {
          this.fetchingDone = true;
          if (unique.length > 0) {
            return this.layoutService.GetLayoutsByIds(unique);
          }
        }),
        tap((layouts: any) => {
          this.additionalLayouts = layouts;
          if (this.recordId != null) {
            let recordsIds = [];
            if (this.recordId.toString().indexOf(',') !== -1) {
              recordsIds = this.recordId.toString().split(',');
            } else {
              recordsIds = [this.recordId];
            }
            this.messageInfo.sendPdf = true;
            recordsIds.forEach((id) => {
              const edit = this.layoutService.getValuesOnEdit(
                this.moduleStructure,
                this.moduleId,
                id
              ) as Observable<object>;
              edit
                .pipe(
                  tap((result: any) => {
                    const recordmodel = JSON.parse(
                      result.Values
                    ) as RecordModel;
                    if (this.layoutId === 'layout_definition_Id') {
                      this.layoutId =
                        this.moduleStructure.module.LayoutDefinitionId;
                    }
                    this.recordModel = recordmodel;
                    const isMainLayout =
                      this.moduleStructure.module.LayoutDefinitionId ===
                      toNumber(this.layoutId);
                    if (isMainLayout) {
                      this.AddDocumentPDF(id, recordmodel);
                    } else {
                      const layout = this.additionalLayouts.find(
                        (x) => x.Id === toNumber(this.layoutId)
                      );
                      // layout.Description += ' ' + id;
                      this.includeAdditionalLayout(layout, true, id);
                    }
                  })
                )
                .subscribe();
            });
          }
          this.isLoading = false;
        })
      )
      .subscribe((m: ModuleStructure) => {});

    this.layoutService
      .moduleInformation(this.moduleId.toString())
      .subscribe((d: ModuleInformation) => {
        this.moduleInformation = d;
        // this.name = this.moduleInformation.PluralName;
        this.moduleInformation.ModuleId = this.moduleId;
      });
  }

  onChange(result: Date): void {}

  onOk(result: Date | Date[] | null): void {
    // moment(new Date(parseInt(value, 0))).format('yyyy-MM-DD');
    this.recontact = result[0];
    this.startTime = result[0]; // .format('HH:mm');
    this.endDate = result[1];
    this.endTime = result[1];
  }

  onCalendarChange(result: Array<Date | null>): void {}

  readFile(inputValue: any): void {
    const file: File = inputValue;
    const myReader: FileReader = new FileReader();

    myReader.onloadend = (e) => {
      this.originFileObj.push({
        fileName: file.name,
        fileBase: myReader.result.toString(),
      });
    };
    myReader.readAsDataURL(file);
  }

  setActivObjectValues(type: CommunicationType, headerLine, moduleName) {
    if (type === 3) {
      this.trackData = true;
      const originFileObjAviliable = [];
      this.fromCommunication = true;
      if (this.fileList.length <= 0) {
        this.originFileObj = null;
        this.fileName = null;
        this.fileBase = null;
      } else if (this.originFileObj.length <= 0) {
        this.fileList.forEach((file, index) => {
          this.readFile(file);
        });
      } else {
        this.fileList.forEach((file, index) => {
          let found = false;
          this.originFileObj.forEach((oFObj, ind) => {
            if (file.name === oFObj.fileName) {
              found = true;
              originFileObjAviliable.push(oFObj);
            }
          });
        });
      }

      originFileObjAviliable.forEach((el, index) => {
        this.fileName.push(el.fileName);
        this.fileBase.push(el.fileBase);
      });
    }

    // if module SalesOpportunities we need last stage id
    let stageId = null;
    let contactPerson = null;
    let docEntry = null;
    let contactPersonObject = null;
    if (this.recordModel.ObjectCode === '97') {
      const stageLines = this.recordModel.Categories.find(
        (x) => x.Id === moduleName + 'Lines'
      );
      const lastStage = this.recordModel.Categories.find(
        (x) => x.Id === moduleName + 'Lines'
      ).Lines[stageLines.Lines.length - 1];
      stageId = lastStage.Properties.find(
        (p) => p.Name === 'StageKey'
      ).ValueAsObject;
      docEntry = this.recordModel.KeyValue;
      if (docEntry === null) {
        docEntry = 0;
      }

      contactPersonObject = headerLine.Properties.find(
        (p) => p.Name === 'ContactPerson'
      );
      contactPerson = contactPersonObject
        ? contactPersonObject.ValueAsObject
        : 0;
    } else if (this.recordModel.ObjectCode === '2') {
      contactPersonObject = headerLine.Properties.find(
        (p) => p.Name === 'ContactPerson'
      );
      contactPerson = contactPersonObject
        ? contactPersonObject.ValueAsObject
        : 0;
      docEntry = headerLine.Properties.find(
        (p) => p.Name === 'CardCode'
      ).ValueAsObject;
    } else if (this.recordModel.ObjectCode === '191') {
      contactPersonObject = headerLine.Properties.find(
        (x) => x.Name === 'ContactCode'
      );
      contactPerson = contactPersonObject
        ? contactPersonObject.ValueAsObject
        : 0;
    } else if (this.recordModel.ObjectCode === '4') {
      contactPerson = '';
      docEntry = headerLine.Properties.find(
        (p) => p.Name === 'ItemCode'
      ).ValueAsObject;
    } else {
      contactPersonObject = headerLine.Properties.find(
        (p) => p.Name === 'ContactPersonCode'
      );
      contactPerson = contactPersonObject
        ? contactPersonObject.ValueAsObject
        : 0;
      const docEntryObj = headerLine.Properties.find(
        (p) => p.Name === 'DocEntry'
      );
      docEntry = docEntryObj ? docEntryObj.ValueAsObject : null;
    }
    let cardCode = null;
    if (this.recordModel.ObjectCode === '191') {
      cardCode = headerLine.Properties.find(
        (x) => x.Name === 'CustomerCode'
      ).ValueAsObject;
    } else if (this.recordModel.ObjectCode === '4') {
      cardCode = '';
    } else {
      cardCode = headerLine.Properties.find(
        (p) => p.Name === 'CardCode'
      ).ValueAsObject;
    }
    // set Communication Parameters
    this.communicatParam = {
      ITM_HELP_ISPUP: this.ITM_HELP_ISPUP,
      CommunicationType: type,
      DocType: +this.recordModel.ObjectCode,
      StageId: stageId,
      CardCode: cardCode,
      DocEntry: docEntry,
      ContactPersonCode: contactPerson,
      Recontact: this.recontact,
      StartTime: this.startTime, // .format('HH:mm');
      EndDate: this.endDate,
      EndTime: this.endTime,
      Remarks: this.remark,
      Notes: this.remark,
      Note_Notes: this.communicatParam.Note_Notes,
      Employees: this.listOfTagOptions,
      Conversation_Recontact: this.communicatParam.Conversation_Recontact,
      Conversation_StartTime: this.communicatParam.Conversation_StartTime,
      Conversation_EndDate: this.communicatParam.Conversation_EndDate,
      Conversation_EndTime: this.communicatParam.Conversation_EndTime,
      Conversation_Employees: this.listOfTagOptions,
      Conversation_Notes: this.communicatParam.Conversation_Notes,
      Meeting_Recontact: this.communicatParam.Meeting_Recontact,
      Meeting_StartTime: this.communicatParam.Meeting_StartTime,
      Meeting_EndDate: this.communicatParam.Meeting_EndDate,
      Meeting_EndTime: this.communicatParam.Meeting_EndTime,
      Meeting_Employees: this.listOfTagOptions,
      Meeting_Notes: this.communicatParam.Meeting_Notes,
      Task_Recontact: this.communicatParam.Task_Recontact,
      Task_StartTime: this.communicatParam.Task_StartTime,
      Task_EndDate: this.communicatParam.Task_EndDate,
      Task_EndTime: this.communicatParam.Task_EndTime,
      Task_Employees: this.listOfTagOptions,
      Task_Notes: this.communicatParam.Task_Notes,
      MsgId: this.emailSubject,
      EmailSubject: this.emailSubject,
      EmailTo: this.emailListOfTagOptions,
      EmailCc: this.cCemailListOfTagOptions,
      // EmailBcc: this.endDate,
      AttachNames: this.fileName,
      AttachData: this.fileBase,
      AttachDoc: this.attachedDocs,
      Email_Employees: this.listOfTagOptions,
      DocFile: '',
      Email_Notes: this.remark,
      Note_Employees: this.listOfTagOptions,
      Token: g.getToken(),
      ITM_ONLINE: this.communicatParam.ITM_ONLINE,
      To: this.emailListOfTagOptions,
      Cc: this.cCemailListOfTagOptions,
      Bcc: null,
      Subject: this.emailSubject,
      HtmlBody: this.remark,
      trackData: this.trackData,
      fromCommunication: this.fromCommunication,
    };
    this.fileList = [];
    this.originFileObj = [];
    this.fileName = [];
    this.fileBase = [];
  }

  tabChange(event) {
    const emailIndex = this.tabs.findIndex((x) => x.label === 'Email');
    if (event.index === emailIndex) {
      // this.emailSubject = this.emailInfo.Details;
      // this.remark = this.emailInfo.Notes;
      this.GetEmailTemplateInfo();
    } else {
      this.remark = '';
    }

    this.listOfTagOptions = [];
  }
  getHeaderLine(moduleName: string) {
    let headerLine;
    if (this.recordModel.ObjectCode === '97') {
      headerLine = this.recordModel.Categories.find((x) => x.Id === moduleName)
        .Lines[0];
      // this.setActivObjectValues(type, headerLine, moduleName);
    } else if (this.recordModel.ObjectCode === '2') {
      headerLine = this.recordModel.Categories.find(
        (x) => x.Id === 'BusinessPartners'
      ).Lines[0];
      // this.setActivObjectValues(type, headerLine, moduleName);
    } else if (this.recordModel.ObjectCode === '191') {
      headerLine = this.recordModel.Categories.find(
        (x) => x.Id === 'ServiceCalls'
      ).Lines[0];
      // this.setActivObjectValues(type, headerLine, moduleName);
    } else if (this.recordModel.ObjectCode === '33') {
      headerLine = this.recordModel.Categories.find((x) => x.Id === 'Contacts')
        .Lines[0];
    } else if (this.recordModel.ObjectCode === '4') {
      headerLine = this.recordModel.Categories.find((x) => x.Id === 'Items')
        .Lines[0];
    } else {
      headerLine = this.recordModel.Categories.find((x) => x.Id === 'Documents')
        .Lines[0];
      // this.setActivObjectValues(type, headerLine, moduleName);
    }
    return headerLine;
  }
  // createCommunication(type: CommunicationType) {
  //   this.isLoading = true;
  //   const moduleName = this.recordModel.ObjectKey.substring(1);
  //   const headerLine = this.getHeaderLine(moduleName);

  //   this.setActivObjectValues(type, headerLine, moduleName);
  //   if (type === CommunicationType.Email) {
  //     this.communicatParam.ITM_ONLINE = 'Y';
  //     if (this.multiDoc) {
  //       this.communicatParam.additionalLayouts =
  //         this.additionalLayoutsToPreview;
  //     } else {
  //       this.communicatParam.additionalLayouts = Array.from(
  //         this.additionalLayoutsToAdd.values()
  //       ).map((x) => {
  //         return {
  //           LayoutId: x,
  //           ModuleId: this.moduleId,
  //           DocEntry: this.recordModel.KeyValue,
  //         };
  //       });
  //     }

  //     if (
  //       this.communicatParam.EmailTo.length > 0 ||
  //       this.communicatParam.EmailCc.length > 0
  //     ) {
  //       this.notification.info(
  //         this.layoutService.translate('Please wait'),
  //         this.layoutService.translate(
  //           'Sending email... \n you can close this window'
  //         )
  //       );
  //     }
  //     const sendMessage$ = this.layoutService
  //       .SendMessage(this.communicatParam)
  //       .pipe(
  //         tap((result: any) => {
  //           if (result.Has_Error) {
  //             this.msg.error(result.Error_Message);
  //           } else {
  //             this.msg.success(
  //               this.layoutService.translate(`Email Sent Successfully`)
  //             );
  //             this.additionalLayoutsToAdd.clear();
  //             this.emailListOfTagOptions = [];
  //             this.additionalLayoutsToPreview = [];
  //             this.remark = '';
  //             this.remarkEm = '';
  //             this.emailSubject = '';
  //             const tokenDocFile = result.Error_Message.split('|');
  //             this.communicatParam.Token = tokenDocFile[1];
  //             this.communicatParam.MsgId = tokenDocFile[0];

  //             if (tokenDocFile.length === 3) {
  //               this.communicatParam.DocFile = tokenDocFile[2];
  //             } else {
  //               this.communicatParam.DocFile = '';
  //             }

  //             this.communicatParam.ITM_ONLINE = 'Y';
  //           }
  //           this.isLoading = false;
  //         }),
  //         switchMap(() => {
  //           if (
  //             this.recordModel.ObjectCode !== '191' &&
  //             this.recordModel.ObjectCode !== '33'
  //           ) {
  //             return this.layoutService.createCommunication(
  //               this.communicatParam
  //             );
  //           }
  //         }),
  //         tap((result: any) => {
  //           console.log('createCommunication result:', result);
  //           if (result.Has_Error) {
  //             this.msg.error(result.Error_Message);
  //           } else {
  //             this.msg.success(
  //               this.layoutService.translate(`Activity Added Successfully`)
  //             );
  //           }
  //           this.isLoading = false;
  //         })
  //       );
  //     const activeAccount = this.msalService.instance.getActiveAccount();
  //     console.log('createCommunication ~ activeAccount', activeAccount);
  //     const activeAccounts = this.msalService.instance.getAllAccounts();
  //     console.log('createCommunication ~ activeAccounts', activeAccounts);
  //     const isLoggedIn = this.msalService.instance.getActiveAccount() != null;
  //     console.log(isLoggedIn);

  //     if (!isLoggedIn) {
  //       this.msalService
  //         .acquireTokenPopup({
  //           scopes: [
  //             'email',
  //             'User.Read',
  //             'IMAP.AccessAsUser.All',
  //             'offline_access',
  //             'https://outlook.office.com/IMAP.AccessAsUser.All', // Only needed for IMAP
  //             //"https://outlook.office.com/POP.AccessAsUser.All",  // Only needed for POP
  //             //"https://outlook.office.com/SMTP.Send", // Only needed for SMTP
  //           ],
  //         })
  //         .pipe(
  //           tap((response: AuthenticationResult) => {
  //             console.log(response);
  //             this.msalService.instance.setActiveAccount(response.account);
  //           }),
  //           switchMap(() => sendMessage$)
  //         )
  //         .subscribe();
  //     } else {
  //       sendMessage$.subscribe();
  //     }
  //   } else {
  //     this.layoutService
  //       .createCommunication(this.communicatParam)
  //       .subscribe((result: any) => {
  //         console.log('createCommunication result:', result);
  //         if (result.Has_Error) {
  //           this.msg.error(result.Error_Message);
  //         } else {
  //           this.msg.success(
  //             this.layoutService.translate(`Activity Added Successfully`)
  //           );

  //           this.ITM_HELP_ISPUP = false;
  //         }
  //         this.isLoading = false;
  //       });
  //   }
  //   this.activitiesList();
  // }
  createCommunication(type: CommunicationType) {
    this.isLoading = true;
    const moduleName = this.recordModel.ObjectKey.substring(1);
    let headerLine;
    if (this.recordModel.ObjectCode === '97') {
      headerLine = this.recordModel.Categories.find((x) => x.Id === moduleName)
        .Lines[0];
      // this.setActivObjectValues(type, headerLine, moduleName);
    } else if (this.recordModel.ObjectCode === '2') {
      headerLine = this.recordModel.Categories.find(
        (x) => x.Id === 'BusinessPartners'
      ).Lines[0];
      // this.setActivObjectValues(type, headerLine, moduleName);
    } else if (this.recordModel.ObjectCode === '191') {
      headerLine = this.recordModel.Categories.find(
        (x) => x.Id === 'ServiceCalls'
      ).Lines[0];
      // this.setActivObjectValues(type, headerLine, moduleName);
    } else if (this.recordModel.ObjectCode === '33') {
      headerLine = this.recordModel.Categories.find((x) => x.Id === 'Contacts')
        .Lines[0];
    } else if (this.recordModel.ObjectCode === '4') {
      headerLine = this.recordModel.Categories.find((x) => x.Id === 'Items')
        .Lines[0];
    } else {
      headerLine = this.recordModel.Categories.find((x) => x.Id === 'Documents')
        .Lines[0];
      // this.setActivObjectValues(type, headerLine, moduleName);
    }
    this.setActivObjectValues(type, headerLine, moduleName);
    console.log('selectedActivitie', this.selectedActivitie);
    if (type === 3) {
      this.communicatParam.ITM_ONLINE = 'Y';
      if (this.multiDoc) {
        this.communicatParam.additionalLayouts =
          this.additionalLayoutsToPreview;
      } else {
        this.communicatParam.additionalLayouts = Array.from(
          this.additionalLayoutsToAdd.values()
        ).map((x) => {
          return {
            LayoutId: x,
            ModuleId: this.moduleId,
            DocEntry: this.recordModel.KeyValue,
          };
        });
      }
      if (
        this.communicatParam.EmailTo.length > 0 ||
        this.communicatParam.EmailCc.length > 0
      ) {
        this.notification.info(
          this.layoutService.translate('Please wait'),
          this.layoutService.translate(
            'Sending email... \n you can close this window'
          )
        );
      }
      this.layoutService
        .SendMessage(this.communicatParam)
        .subscribe((result: any) => {
          console.log('createCommunication Email result:', result);
          if (result.Has_Error) {
            this.msg.error(result.Error_Message);
          } else {
            this.msg.success(
              this.layoutService.translate(`Email Sent Successfully`)
            );
            this.additionalLayoutsToAdd.clear();
            this.emailListOfTagOptions = [];
            this.additionalLayoutsToPreview = [];
            this.remark = '';
            this.remarkEm = '';
            this.emailSubject = '';
            const tokenDocFile = result.Error_Message.split('|');
            this.communicatParam.Token = tokenDocFile[1];
            this.communicatParam.MsgId = tokenDocFile[0];

            if (tokenDocFile.length === 3) {
              this.communicatParam.DocFile = tokenDocFile[2];
            } else {
              this.communicatParam.DocFile = '';
            }

            this.communicatParam.ITM_ONLINE = 'Y';
            if (
              this.recordModel.ObjectCode !== '191' &&
              this.recordModel.ObjectCode !== '33'
            ) {
              this.layoutService
                .createCommunication(this.communicatParam)
                .subscribe((resu: any) => {
                  console.log('createCommunication result:', resu);
                  if (resu.Has_Error) {
                    this.msg.error(resu.Error_Message);
                  } else {
                    this.msg.success(
                      this.layoutService.translate(
                        `Activity Added Successfully`
                      )
                    );
                  }
                  this.isLoading = false;
                });
            }
          }
          this.isLoading = false;
        });
    } else {
      this.layoutService
        .createCommunication(this.communicatParam)
        .subscribe((result: any) => {
          console.log('createCommunication result:', result);
          if (result.Has_Error) {
            this.msg.error(result.Error_Message);
          } else {
            this.msg.success(
              this.layoutService.translate(`Activity Added Successfully`)
            );

            this.ITM_HELP_ISPUP = false;
          }
          this.isLoading = false;
        });
    }
    this.activitiesList();
    console.log('RecordModel: ', this.recordModel);
    console.log('CommunicationParameter: ', this.communicatParam);
  }
  edit(item: any): void {
    this.msg.success(item.email);
  }
  activitiesList() {
    // this.isLoading = true;
    // this.remark = '';
    // this.listOfTagOptions = [];
    this.layoutService
      .activitiesList(this.recordModel.ObjectCode, this.recordId)
      .subscribe((result: { rows: any[] }) => {
        // tslint:disable-next-line: forin
        const children: any[] = [];
        // tslint:disable-next-line: forin
        for (const key in result.rows) {
          children.push(result.rows[key]);
        }
        this.emailInfo = result.rows[0];

        let chkGrp: any[] = [];
        children.map((item) => {
          const existItem = chkGrp.find(
            (x) => x.U_ITM_ACT_GUID === item.U_ITM_ACT_GUID
          );
          if (existItem) {
            if (item.AttendEmpl !== ' ' && existItem.AttendEmpl !== '') {
              existItem.AttendEmpl =
                existItem.AttendEmpl + ',' + item.AttendEmpl;
            } else if (item.AttendEmpl !== ' ') {
              existItem.AttendEmpl = item.AttendEmpl;
            }
            if (item.AttendUser !== ' ' && existItem.AttendUser !== '') {
              existItem.AttendUser =
                existItem.AttendUser + ',' + item.AttendUser;
            } else if (item.AttendUser !== ' ') {
              existItem.AttendUser = item.AttendUser;
            }
          } else {
            chkGrp.push(item);
          }
        });
        chkGrp = chkGrp.sort((a, b) => {
          const dataA = new Date(a.Recontact);
          const dataB = new Date(b.Recontact);
          if (dataA > dataB) {
            return -1;
          } else if (dataA < dataB) {
            return 1;
          } else {
            return 0;
          }
        });
        // chkGrp = chkGrp.sort((a, b) => {
        //   const dataA = a.BeginTime;
        //   const dataB = b.BeginTime;
        //   if (dataA > dataB) { return -1; }
        //   else if (dataA < dataB) { return 1; }
        //   else { return 0; }
        // });
        this.activitiesData = chkGrp;
        this.isLoading = false;
      });
  }

  emailList(value: string = '') {
    this.layoutService.parameterDataSource(value).subscribe((result) => {
      // tslint:disable-next-line: forin
      const children: Array<{ label: string; value: string }> = [];
      // tslint:disable-next-line: forin
      for (const key in result) {
        children.push({ label: result[key].id, value: result[key].text });
      }

      this.emailListOfOption = children;
      this.isLoading = false;
    });
  }

  handleUpload(): void {
    const formData = new FormData();
    // tslint:disable-next-line:no-any
    this.fileList.forEach((file: any) => {
      formData.append('files[]', file);
    });
    this.uploading = true;
  }

  getColor() {
    // tslint:disable-next-line: no-bitwise
    return '#' + (((1 << 24) * Math.random()) | 0).toString(16);
  }

  groupBy(list, keyGetter) {
    const mappedObject = new Map();
    list.forEach((item) => {
      const key = keyGetter(item);
      const collection = mappedObject.get(key);
      if (!collection) {
        mappedObject.set(key, [item]);
      } else {
        collection.push(item);
      }
    });
    return mappedObject;
  }

  navigateTo(model, id) {
    RecordPageComponent.openRecordPage(this.drawerService, {
      actionType: this.moduleInformation.AuthorisedForEdit ? 'Edit' : 'View',
      drawerTitle: `Activity: ${id}`,
      inDrawer: true,
      moduleId: Number(model),
      parentComponent: this,
      recordId: id,
      recordModel: undefined,
    });
  }
  AddDocumentPDF(docEntry = '', recordmodel = null) {
    if (recordmodel != null) {
      this.recordModel = recordmodel;
    }
    const docEnt = docEntry === '' ? this.recordModel.KeyValue : docEntry;
    this.communicatParam.AttachDoc = [];
    if (this.messageInfo.sendPdf) {
      if (this.recordModel.ObjectCode === '97') {
        this.layoutService
          .GetOpportunityDocument(docEnt)
          .subscribe((response: any) => {
            if (response.length !== 0 && response.rows[0].ObjType !== '-1') {
              this.layoutService
                .moduleIdByType(response.rows[0].ObjType)
                .subscribe((data: any) => {
                  this.GetModulePDF(
                    response.rows[0].DocId,
                    response.rows[0].ObjType,
                    data
                  );
                });
            } else if (response.data.rows[0].ObjType === '-1') {
              // setStatusMsg(translate("There is no document to be attached.
              // /Maybe you have to update the Opportunity before sending a communication email"), 'error');
              this.messageInfo.sendPdf = false;
            }
          });
      } else {
        this.GetModulePDF(docEnt, this.recordModel.ObjectCode, this.moduleId);
      }
    }
  }
  GetModulePDF(docEntry, docType, moduleId) {
    this.layoutService.moduleInformation(moduleId).subscribe((res: any) => {
      if (
        res.layoutDefinitionId === undefined ||
        res.layoutDefinitionId === ''
      ) {
        // setStatusMsg(translate("There is no layout definition for this module"), 'error');
        this.messageInfo.sendPdf = false;
      }

      if (this.messageInfo.sendPdf) {
        const attachDocItem = {
          DocEntry: docEntry,
          ObjType: docType,
          ModuleId: moduleId,
          AttachName: docEntry,
        };
        // this.communicatParam.AttachDoc.push(attachDocItem);
        this.attachedDocs.push(attachDocItem);
      }
    });
  }
  GetEmailTemplateInfo() {
    this.layoutService
      .GetEmailTemplateInfo(this.moduleId)
      .pipe(
        tap((response: any) => {
          let subject = '';
          let body = '';
          let sign = '';
          // tslint:disable-next-line: no-shadowed-variable
          Object.keys(response.rows).forEach((element: any) => {
            if (
              response.rows[element].EmailSubjectTemplate != null &&
              response.rows[element].EmailSubjectTemplate !== undefined
            ) {
              subject = response.rows[element].EmailSubjectTemplate;
            }
            if (
              response.rows[element].EmailBodyTemplate != null &&
              response.rows[element].EmailBodyTemplate !== undefined
            ) {
              body = response.rows[element].EmailBodyTemplate;
            }
            if (
              response.rows[element].signature != null &&
              response.rows[element].signature !== undefined
            ) {
              sign = response.rows[element].signature;
            }
          });
          let modelProperties;
          let CardName = '';
          let recordNum = this.recordId.toString();
          if (this.recordModel.ObjectCode === '191') {
            modelProperties = this.recordModel.Categories.find(
              (x) => x.Id === 'ServiceCalls'
            ).Lines[0].Properties;
            CardName = modelProperties.find(
              (x) => x.Name === 'CustomerName'
            ).ValueAsObject;
          } else if (this.recordModel.ObjectCode === '33') {
            modelProperties = this.recordModel.Categories.find(
              (x) => x.Id === 'Contacts'
            ).Lines[0].Properties;
            CardName = modelProperties.find(
              (x) => x.Name === 'CardName'
            ).ValueAsObject;
          } else {
            modelProperties = this.recordModel.Categories.find(
              (x) => x.Id === 'Documents'
            ).Lines[0].Properties;
            CardName = modelProperties.find(
              (x) => x.Name === 'CardName'
            ).ValueAsObject;
            recordNum = modelProperties.find(
              (x) => x.Name === 'DocNum'
            ).ValueAsObject;
          }
          subject = subject.replace('{#DocNum}', recordNum);
          body = body.replace('{#CardName}', CardName);
          this.emailSubject = subject;
          this.remark = body.concat('<br> <br>' + sign);
        })
      )
      .subscribe();
  }
}
